import React from 'react';

export default function SocialMediaItem({ item, width }: any) {
  return (
    <div className="first:ml-0 mx-1.5">
      <a
        href={item.url}
        target="_blank"
        rel="noreferrer"
      >
        <img src={item.icon?.url} alt={item.icon?.description} width={width} />
      </a>
    </div>
  );
}
